// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1wa6M","footer":"ModalInfo_footer__qBawl"};